// extracted by mini-css-extract-plugin
export var orderDetails = "_rc-2";
export var orderImage = "_rc-1";
export var orderMeta = "_rc-3";
export var orderSummary = "_rc-0";
export var rightArrow = "_rc-4";